import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Spinner } from '@/components';
import { Button } from '@/components/ui';

interface FeedLoadMoreProps {
    hasMore: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => void;
    auto?: boolean;
}

export function FeedLoadMore({
    hasMore,
    isLoadingMore,
    onLoadMore,
    auto = false,
}: FeedLoadMoreProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);

    if (isLoadingMore) {
        return (
            <div className="flex justify-center py-3">
                <div className="flex items-center gap-2 text-grey-300 text-sm">
                    <Spinner size={16} />
                    <span>{t('page.loading')}</span>
                </div>
            </div>
        );
    }

    if (!hasMore || auto) return null;

    return (
        <div className="flex justify-center py-3">
            <Button variant="ghost" size="small" onClick={onLoadMore}>
                {t('page.loadMore')}
            </Button>
        </div>
    );
}
